import { Head, Link } from "@inertiajs/react"
import { ArrowLeft } from "@untitledui/icons"

import { Notice } from "@/components/ui/notice"
import { AdminLayout } from "@/layouts/admin-layout"
import { adminCallListsPath } from "@/routes"

interface Props {
  school: {
    id: number
    name: string | null
    region: string | null
    sub_region: string | null
  }
  scopes: { id: number; label: string }[]
  /** The scopes this school was added to by hand; each add queued a refresh. */
  added_to: string[]
}

/** A mirrored school no scope has refreshed yet: there is no document to build a card from. */
export default function AdminSchoolsUnsnapshotted({
  school,
  scopes,
  added_to,
}: Props) {
  return (
    <AdminLayout>
      <Head title={`${school.name ?? "School"} · Call list`} />
      <div className="mx-auto flex max-w-3xl flex-col gap-6 px-4 lg:px-8">
        <Link
          href={adminCallListsPath()}
          className="text-tertiary hover:text-secondary inline-flex w-max items-center gap-1.5 text-sm font-medium transition-colors"
        >
          <ArrowLeft className="size-4" /> Back to call lists
        </Link>
        <h1 className="text-display-xs text-primary">{school.name}</h1>
        {added_to.length > 0 && (
          <Notice tone="info" role="status">
            Added by hand to {added_to.join(" and ")}. A refresh is on its way;
            the card fills in when it lands.
          </Notice>
        )}
        <Notice tone="info" role="status">
          No relationship has been computed for this school yet. It is in{" "}
          {school.sub_region ?? school.region ?? "an unknown region"};
          {scopes.length > 0
            ? " refresh the scope that covers it, or add the school to a list by hand."
            : " no call-list scope exists yet."}
        </Notice>
      </div>
    </AdminLayout>
  )
}
